export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";